module.exports = __webpack_public_path__ + "static/media/19_after.bcdbb40c.jpg";